export function handleFilteredStringOptions(options: string[], selectedOptions: string[]): string[] {
  const filteredArray = options.filter((value) => !selectedOptions.includes(value));

  if (filteredArray.length > 0) {
    return [...selectedOptions, ...filteredArray];
  }

  return options;
}
